import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as actions from './../../../actions';
import FieldWrapper from './FieldWrapper';
import ImageModal from '../../Editors/ImageModal';
import Image from '../../../../components/svg/Image';
import { RootState } from 'gf-types';
import { ValueChangedForFieldFunc } from '../../../formeditor-types';

export interface ImageFieldProps {
  valueUpdated: ValueChangedForFieldFunc;
  id?: string;
  fieldId?: string;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  align?: string;
  padding?: number;
  backgroundColor?: TypeMePlease;
  editable?: boolean;
  value?: string;
  sasToken?: TypeMePlease;
  imageQuality?: string;
  retainImageAsAttachment?: string;
  dateStamp: boolean;
  fontSize?: number;
  fontName?: string;
  foregroundColor?: TypeMePlease;
  formId?: string;
  name?: string;
  fileUrls?: TypeMePlease;
  rowNumber?: number;
  maxSize?: number;
  getSharedFormImageUrl?: AnyFunc;
  color?: TypeMePlease;
  openOcrImagePickerModal?: AnyFunc;
}

//@ts-ignore - FIX
@connect(
  (state: RootState) => ({
    sasToken: state.shared.sasToken,
    fileUrls: state.formeditor.fileUrls
  }),
  actions
)
export default class ImageField extends PureComponent<ImageFieldProps, TypeMePlease> {
  constructor(props) {
    super(props);

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);

    this.state = {
      modalOpen: false
    };
  }

  getFilePath(fileId) {
    if (this.props.fileUrls) {
      return this.props.fileUrls[fileId];
    }
    if (this.props.sasToken) {
      return `${this.props.sasToken.baseUrl}${fileId}${this.props.sasToken.token}`;
    }
    return null;
  }

  handleMouseDown() {
    this.setState({ modalOpen: true });
  }

  handleModalClose() {
    this.setState({ modalOpen: false });
  }

  render() {
    let image = null;
    let imageModal = null;
    let existingImageUrl = null;
    let existingImageFileId = null;

    if (this.props.value) {
      const properties = JSON.parse(this.props.value);
      existingImageUrl = this.getFilePath(properties.FileId);
      existingImageFileId = properties.FileId;
      image = <Image src={existingImageUrl} align={this.props.align} padding={this.props.padding} w={this.props.w} h={this.props.h} />;
    }

    if (this.state.modalOpen) {
      imageModal = (
        <ImageModal
          promptDeleteExisting={!!this.props.value}
          valueUpdated={this.props.valueUpdated}
          onClose={this.handleModalClose}
          imageQuality={this.props.imageQuality}
          retainImageAsAttachment={this.props.retainImageAsAttachment}
          width={this.props.w}
          height={this.props.h}
          dateStamp={this.props.dateStamp}
          fontSize={this.props.fontSize}
          fontName={this.props.fontName}
          color={this.props.color}
          formId={this.props.formId}
          fieldName={this.props.name}
          fieldId={this.props.fieldId}
          rowNumber={this.props.rowNumber}
          fileUrls={this.props.fileUrls}
          getSharedFormImageUrl={this.props.getSharedFormImageUrl}
          openOcrImagePickerModal={this.props.openOcrImagePickerModal}
          existingImageUrl={existingImageUrl}
          existingImageFileId={existingImageFileId}
        />
      );
    }

    return (
      <FieldWrapper
        x={this.props.x}
        y={this.props.y}
        w={this.props.w}
        h={this.props.h}
        backgroundColor={this.props.backgroundColor}
        editable={this.props.editable}
        onMouseDown={this.handleMouseDown}
        id={this.props.id}
        fieldId={this.props.fieldId}
      >
        {image}
        {imageModal}
      </FieldWrapper>
    );
  }
}
